import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const footerLinks = {
  explore: [
    { name: '首页', href: '/' },
    { name: '关于我们', href: '/about' },
  ],
  categories: categories.map((c) => ({ name: c.name, href: `/category/${c.slug}` })),
};

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          <div>
            <h3 className="text-lg font-heading font-bold mb-4">原神本子精选</h3>
            <p className="text-sm text-background-50/80 leading-relaxed max-w-xs">
              探索海量原神同人创作，涵盖各大角色同人漫画、插画本、小说本等丰富内容。
              为原神同人爱好者提供最全面的资讯与推荐平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50/90">快速导航</h4>
            <ul className="space-y-2">
              {footerLinks.explore.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50/90">分类浏览</h4>
            <ul className="space-y-2">
              {footerLinks.categories.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-50/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/60">
            &copy; {new Date().getFullYear()} 原神本子精选。本站为同人爱好者交流平台，所有内容版权归原作者所有。
          </p>
          <p className="text-xs text-background-50/60">
            原神 &copy; miHoYo / HoYoverse
          </p>
        </div>
      </div>
    </footer>
  );
}